import { useGenericDialog } from '~/composables/useGenericDialog';

export const usePermissionGuard = () => {
    const router = useRouter();
    const { t } = useI18n();
    const { openGenericAlert } = useGenericDialog();

    const guard = (
        condition: boolean,
        opts?: {
            titleKey?: string;
            contentsKey?: string;
            redirectTo?: any;
        }
    ) => {
        if (condition) return true;

        const redirectTo = opts?.redirectTo ?? { path: "/dashboard" };
        const go = () => router.replace(redirectTo);

        openGenericAlert(
            {
                title: t(opts?.titleKey ?? "skillMonitor-main-limit-permission-title"),
                contents: t(opts?.contentsKey ?? "skillCertify-limit-permission-description"),
                popupClass: 'dark',
            },
            {
                confirm: { title: t("common-ok"), event: go },
                close: { event: go },
            }
        );

        return false;
    };

    return { guard };
};
